import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MinuteRequestApprovalRuleIndexComponent } from './minute-request-approval-rule-index/minute-request-approval-rule-index.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path	: '',
        component: MinuteRequestApprovalRuleIndexComponent,
        data: {
          urls: [
            { title: 'Reglas Aprobación', url: 'setting/minute-approval-rules'}
          ]
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MinuteRequestApproveRuleSettingRoutingModule { }
